import type Handlebars from "handlebars";

/** {{join a b c sep=" · "}} or {{#join sep=", "}}…{{/join}}.
 * Inline form joins positional args with sep, skipping empty/nullish values.
 * Block form splits inner content by newline, trims each line, drops blanks,
 * and joins the survivors with sep so authors can guard items with {{#if}}
 * without producing dangling separators. */
function joinHelper(this: unknown, ...args: unknown[]): string {
  const options = args.pop() as Handlebars.HelperOptions;
  const sep = (options.hash?.sep as string | undefined) ?? ", ";
  if (typeof options.fn === "function") {
    return options
      .fn(this)
      .split("\n")
      .map((s: string) => s.trim())
      .filter(Boolean)
      .join(sep);
  }
  return args
    .filter((v) => v !== null && v !== undefined && v !== "" && v !== false)
    .map(String)
    .join(sep);
}

/** Shared helpers registered against every Handlebars instance we use. */
const sharedHandlebarHelpers = {
  join: joinHelper,
};

/** Register shared helpers on any Handlebars instance (the default import or
 * an isolated one created via Handlebars.create()). */
export function registerSharedHandlebarHelpers(instance: typeof Handlebars) {
  for (const [name, fn] of Object.entries(sharedHandlebarHelpers)) {
    instance.registerHelper(name, fn);
  }
}
